import { KPI_BY_ID, meetsKpi, type KpiId } from '@serb/shared';
import { getSettings } from './settingsStore';

/** The acceptable rate Ibraheem set for a KPI */
export const kpiTarget = (id: KpiId) => getSettings().kpis[id];

/** Is the actual number acceptable? */
export const kpiMet = (id: KpiId, actual: number) => meetsKpi(id, actual, getSettings().kpis);

/** "≥ 8%" / "≤ 10%" / "≥ JOD 300": how the target reads next to a number */
export function kpiTargetText(id: KpiId): string {
  const def = KPI_BY_ID[id];
  const n = kpiTarget(id);
  const value =
    def.unit === '%' ? `${n}%` : def.unit === 'JOD' ? `JOD ${n}` : `JOD ${n.toFixed(2)}${def.unit.slice(3)}`;
  return `${def.better === 'higher' ? '≥' : '≤'} ${value}`;
}
